import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import type { InsuranceQuoteRequestDTO } from '~/dto/Insurance/insuranceQuoteRequestDTO';
import type { InsuranceQuoteResponseDTO } from '~/dto/Insurance/insuranceQuoteResponseDTO';
import type { InsuranceQuoteEntity } from '~/domain/Insurance/insuranceQuoteEntity';
import { insuranceQuoteResponseMapper } from '~/mappers/Insurance/insuranceQuoteResponseMapper';
import Env from '~/env';

export async function doInsuranceQuoteUseCase(
  insuranceQuoteRequestDTO: InsuranceQuoteRequestDTO
): Promise<InsuranceQuoteEntity> {
  try {
    const response = await apiAssegurouAuto.post<InsuranceQuoteResponseDTO>(
      `/auto/cotacao/`,
      {
        ...insuranceQuoteRequestDTO,
        fornecedorId: Env.AUTO_SUPPLIER_ID,
        landingPageId: Env.AUTO_LANDING_PAGE_ID,
        origemId: Env.AUTO_ORIGIN_ID,
      }
    );
    return insuranceQuoteResponseMapper(response.data);
  } catch (error) {
    return {
      insuranceQuotes: [],
      success: false,
    };
  }
}
